import { default as CantPostView } from './CantPostView';
import { default as CantPostViewNew } from '../CantPostView.editor_comment';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CantPostViewNew
})(CantPostView);

//# sourceMappingURL=index.js.map